import CopyPassword from "@core-components/credentials/CopyPassword";
import CopyUsername from "@core-components/credentials/CopyUsername";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Stack, Text } from "@mantine/core";
import type { ExtendedBasketAccount } from "@modules/order/models/IOrder";
import { BOLD_TEXT_CLASS_NAME } from "@modules/order/pages/OrderTracking";

const AccountCredential: React.FC<ExtendedBasketAccount> = ({
  password,
  i18nKey,
  prefix,
  username,
}) => {
  const { t } = useAppTranslation();
  return (
    <Stack gap={5}>
      <Text className={`${BOLD_TEXT_CLASS_NAME} text-lg`}>
        {t(`${i18nKey}.name`, { prefix })}
      </Text>
      <Group className="justify-start gap-5 xs:gap-16 pb-2 md:pb-4">
        <Stack className="gap-0 xs:gap-1 md:gap-0">
          <Text className={`${BOLD_TEXT_CLASS_NAME} text-lg`}>
            {t("pages.order.tracking.credentials.username")}
          </Text>
          <CopyUsername username={username} />
        </Stack>
        <Stack className="gap-0 xs:gap-1 md:gap-0">
          <Text className={`${BOLD_TEXT_CLASS_NAME} text-lg`}>
            {t("pages.order.tracking.credentials.password")}
          </Text>
          <CopyPassword password={password} />
        </Stack>
      </Group>
    </Stack>
  );
};

export default AccountCredential;
